import { User } from '../types/types';

export function getUserFullName({ first_name, last_name }: User) {
  return `${first_name} ${last_name}`.trim();
}
